import React, { useState, useEffect } from 'react';
import { Row, Col, Select } from 'antd';
import FormItem from 'src/components/form-item';
import { noop } from 'lodash';
import './style.scss';
import { useTranslation } from "react-i18next";

const { Option } = Select;

/**
 * FilterByProfile component - used in CommentModal.
 *
 * @param {Object} props - Props for the FilterByProfile component.
 * @param {function} props.onSearch - The function to be called when changing the filter profile value.
 * @param {Array<{value: string, label: string}>} props.profileOptions - The options for the profile list selection.
 * @returns {JSX.Element} The FilterByProfile component.
 * @example
 *  <FilterByProfile
      onSearch={handleSetFilter}
      profileOptions={profileOptions}
    />
 */
function FilterByProfile({ onSearch, profileOptions }) {
  const [profile, setProfile] = useState('');

  // TI profile shouldn't be able to comment
  const options = profileOptions.filter(item => item.value !== "TI").map((item, key) => (
    <Option value={item.value} key={key}>{item.label}</Option>
  ));

  const {t} = useTranslation();

  useEffect(() => {
    onSearch(profile);
  }, [profile, onSearch]);

  return (
    <div id="filter-container">
      <Row gutter={5}>
        <Col span={5}>
          <FormItem label={t('filter')}>
            <Select
              id="status-filter"
              value={profile}
              onChange={setProfile}>
              {options}
            </Select>
          </FormItem>
        </Col>
      </Row>
    </div>
  );
}

FilterByProfile.defaultProps = {
  onSearch: noop,
  profileOptions: [],
};

export default FilterByProfile;
